import axios from "axios";
import {CURRENT_DOMAIN_CRM} from "../../config";

export const getStyleListMethod = () => axios.get(`${CURRENT_DOMAIN_CRM}/api/v1/get-style-list`);
